export default "__VITE_ASSET__BmwBFG1f__"